import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'

const ConfirmModal = ({ 
	isOpen, 
	toggle, 
	onConfirm, 
	title = 'Confirm Action', 
	message = 'Are you sure you want to proceed?',
	confirmText = 'Delete',
	cancelText = 'Cancel',
	confirmColor = 'danger'
}) => {
	const handleConfirm = () => {
		onConfirm()
		toggle()
	}

	return (
		<Modal isOpen={isOpen} toggle={toggle} centered>
			<ModalHeader toggle={toggle}>{title}</ModalHeader>
			<ModalBody>
				<p className="mb-0">{message}</p>
			</ModalBody>
			<ModalFooter>
			<Button 
				color="light" 
				onClick={toggle}
				style={{ 
					backgroundColor: '#6c757d', 
					borderColor: '#6c757d',
					color: '#000'
				}}
			>
				{cancelText}
			</Button>
			<Button color={confirmColor} onClick={handleConfirm}>
				{confirmText}
			</Button>
		</ModalFooter>
		</Modal>
	)
}

export { ConfirmModal }
